import { clientApi } from '../../configuration';
import { getCRUDHooks } from '../../utils';

const { useFind: useSuggestedCourses } = getCRUDHooks({
  entityName: 'suggestedCourses',
  find: ({ teamId }) =>
    clientApi.getOCClient().helpers.employer.teams.id(teamId).suggestedCourses.find(),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useSuggestedCourses,
};
